// Import Core
import React from "react";
import styled from "styled-components";
// Import Components
import Video from "../ui/Video";
import { toSlug } from '../../utils/search/toSlug';

/* Styled Components */
const VideoBlockStyles = styled.section`
  background: var(--white);
  padding: var(--global-padding);
  @media (max-width: 768px) {
    padding: var(--global-padding-mobile);
  }
  > div {
    display: flex;
    flex-direction: column;
    gap: 64px;
    .section-copy {
      text-align: center;
      max-width: 768px;
      margin: auto;
      .subheading {
        color: var(--red);
        font-family: "LTC Goudy Oldstyle Pro";
        font-style: italic;
        line-height: 130%;
        padding-bottom: 12px;
      }
      .title {
        padding-bottom: 24px;
        @media (max-width: 768px) {
          padding-bottom: 40px;
        }
      }
      .description {
        color: var(--neutral-75);
        font-size: 18px;
      }
    }

    .large-cards {
      display: flex;
      gap: 32px;
      @media (max-width: 768px) {
        flex-direction: column;

        .video-description {
          display: none;
        }
      }
      .large-card {
        flex: 1;
        &:nth-child(2) {
          padding-right: 0;
          border-right: none;
          @media (min-width: 768px) {
            padding-left: 32px;
            border-left: 1px solid var(--neutral-10);
          }
        }
      }
    }
    @media (min-width: 768px) {
      .video-controls {
        
        .left {
          gap: 32px;
        }

        .playPauseButton, .fullscreen {
          height: unset;
          min-width: 80px;
          min-height: 80px;
          align-self: stretch;
        }
        .video-copy {
          max-width: 768px;

          .video-caption {
            padding: 12px 0 16px;
          }
          .video-description {
            padding-bottom: 24px;
          }
        }
      }
    }
    .twoCard {
      .video-description {
        display: none;
      }
    }
  }
`;

/* Render Component */
const VideoBlock = ({
  videoSectionTitle,
  videoSectionSubheading,
  videoSectionDescription,
  addToAnchor,
  anchorTitle,
  videos,
}) => {
  const oneCard = videos && videos.length === 1 ? videos.slice(0, 1) : null;
  const twoCard = videos && videos.length === 2 ? videos.slice(0, 2) : null;
  
  return (
    <VideoBlockStyles
      id={(addToAnchor && anchorTitle) ? `anchor_${toSlug(anchorTitle)}` : ''}
      className={(addToAnchor && anchorTitle) && "anchor-link"}
    >
      <div>
        <div className="section-copy">
          {videoSectionSubheading && (
            <p className="subheading">{videoSectionSubheading}</p>
          )}
          {videoSectionTitle && <h2 className="title">{videoSectionTitle}</h2>}
          {videoSectionDescription && (
            <p className="description">{videoSectionDescription}</p>
          )}
        </div>
        <div
          className={`large-cards ${
            oneCard ? "oneCard" : twoCard ? "twoCard" : ""
          }`}
        >
          {oneCard &&
            oneCard.map((card, index) => (
              <div className="large-card" key={index}>
                <Video
                  video={{
                    videoTitle: card.videoTitle,
                    videoURL: card.videoURL,
                    videoDescription: card.videoDescription,
                  }}
                />
              </div>
            ))}
          {twoCard &&
            twoCard.map((card, index) => (
              <div className="large-card" key={index}>
                <Video
                  video={{
                    videoTitle: card.videoTitle,
                    videoURL: card.videoURL,
                    videoDescription: card.videoDescription,
                  }}
                />
              </div>
            ))}
        </div>
      </div>
    </VideoBlockStyles>
  );
};

export default VideoBlock;
